import React, { useState } from "react";
import "../css/AdminLogin.css";
import { FaUserAlt, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

function AdminLogin({ setIsAdmin }) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [otp, setOtp] = useState("");
const [otpSent, setOtpSent] = useState(false);
const [loading, setLoading] = useState(false);

const [serverOtp, setServerOtp] = useState("");


  const navigate = useNavigate();

  // const handleLogin = async () => {
  //   setError("");

  //   if (!email || !password) {
  //     setError("Please fill all fields");
  //     return;
  //   }

  //   try {
  //     const response = await axios.put(
  //       "https://api.krimotion.in/admin-login",
  //       {
  //         id: email,        
  //         pass: password,    
  //       },
        
        
  //     );

  //     const user = response.data;

 

  //     if (user) {
  //       localStorage.setItem("isAdmin", "true");
  //       localStorage.setItem("userData", JSON.stringify(user));
  //       setIsAdmin(true);

  //       navigate("/admin/admin-dashboard");
  //     }
  //   } catch (err) {
  //     console.error("Login error:", err.response?.data || err.message);
  //     setError("Invalid credentials");
  //   }
  // };

const sendOtp = async () => {
  try {
    const res = await axios.post(
      "https://api.krimotion.in/send-admin-login-otp",
      { email }
    );

    setServerOtp(res.data.otp);
    setOtpSent(true);

    toast.success("OTP sent successfully");
  } catch (err) {
    setError(err.response?.data?.message);
  }
};

const handleLogin = async () => {
  if (otp !== serverOtp) {
    setError("Invalid OTP");
    return;
  }

  try {
    const response = await axios.put(
      "https://api.krimotion.in/admin-login",
      {
        email,
      }
    );

    localStorage.setItem("isAdmin", "true");
    localStorage.setItem("userData", JSON.stringify(response.data));
    setIsAdmin(true);

        toast.success("Login successfully");

    navigate("/admin/admin-dashboard");
  } catch (err) {
    setError(err.response?.data?.message);
  }
};
  

  return (
    <div className="admin-login-page d-flex justify-content-center align-items-center">
      <div className="container">
        <div className="row login-card shadow-lg rounded-4 overflow-hidden">

          {/* Left Side */}
          <div className="col-md-5 left-panel text-white d-flex flex-column justify-content-center align-items-center p-5">
            <h1 className="fw-bold mb-3">Welcome Back!</h1>
            <p className="text-center mb-4">
              Login to access the Admin Dashboard
            </p>
          </div>

          {/* Right Side */}
          <div className="col-md-7 bg-white d-flex justify-content-center align-items-center p-5">
            <div className="w-100" style={{ maxWidth: "420px" }}>

              <h2 className="text-center fw-bold login-title mb-4">
                Admin Login
              </h2>

              {/* Email */}
              <div className="input-group mb-3">
                <span className="input-group-text bg-light border-0">
                  <FaUserAlt />
                </span>

                <input
                  type="text"
                  className="form-control border-0 bg-light"
                  placeholder="Enter Email / ID"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {/* Password */}
              {/* <div className="input-group mb-3">
                <span className="input-group-text bg-light border-0">
                  <FaLock />
                </span>

                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control border-0 bg-light"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <span
                  className="input-group-text bg-light border-0"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div> */}

              {otpSent && (
  <div className="input-group mb-3">
    <span className="input-group-text bg-light border-0">
      <FaLock />
    </span>

    <input
      type="text"
      className="form-control border-0 bg-light"
      placeholder="Enter OTP"
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
    />
  </div>
)}

              {/* Error */}
              {error && (
                <p className="text-danger text-center">{error}</p>
              )}

              {/* Button */}
              <div className="d-grid">
                {/* <button
                  className="btn login-btn rounded-pill py-2"
                  onClick={handleLogin}
                >
                  LOGIN
                </button> */}

                {!otpSent ? (
  <button
    className="btn login-btn rounded-pill py-2"
    onClick={sendOtp}
  >
    Send OTP
  </button>
) : (
  <button
    className="btn login-btn rounded-pill py-2"
    onClick={handleLogin}
  >
    Login
  </button>
)}
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AdminLogin;